import React, { useState, useMemo, useLayoutEffect, useEffect } from "react";
import {
  Input,
  Select,
  Button,
  Tag,
  Layout,
  Checkbox,
  Image,
  Tabs,
} from "antd";
import {
  SearchOutlined,
  ShoppingCartOutlined,
  DownOutlined,
  HistoryOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs"
import ProductTable from "../../component/product/ProductTable";
import { useAppContext } from "../../context/AuthContext";
import CartDrawer from "../../component/Drawer";
import { products } from "../../data";
import HeaderCompo from "../../component/Header";
import logo from "../../assets/marketPlacelogo.png";
import { axiosInstance } from "../../utils/axiosInterceptor";
import logopharm from "../../assets/marketplacepharmlogo.png";
import { useSelector } from "react-redux";
import "./ProductDetails.css";
import PurchaseHistory from "./purchaseHistory/PurchaseHistory";
const { Content } = Layout;
const { Option } = Select;
const { TabPane } = Tabs;
const StaticAccounts = ({ selectedAccounts = [], accountMap }) => {
  const [expanded, setExpanded] = useState(false);

  const visibleAccounts = expanded
    ? selectedAccounts
    : selectedAccounts.slice(0, 2);

  return (
    <div
      className="w-full md:w-[400px] min-h-[40px] flex flex-wrap items-center gap-2 px-2 py-1"
      style={{
        border: "1px solid #fff",
        borderRadius: "6px",
        minHeight: "70px",
        // background: "#fff",
      }}
    >
      {visibleAccounts.map((acctId) => (
        <div className="flex gap-2 items-center">
          {/* <div>
          <Image
            style={{marginBottom:"28px"}}
            src={logopharm}
            alt="Logo"
            preview={false}
            className=" rounded-md"
            width={40}
            height={40}
          />
          </div> */}
          <div>
            <Tag
              key={acctId}
              closable={false}
              style={{
                border: "none",
                backgroundColor: "transparent",
                borderRadius: "3px",
                padding: "4px 12px",
                fontSize: "20px",
                color: "#fff",
                fontWeight: "700",
              }}
            >
              {accountMap[acctId]}
            </Tag>
          </div>
        </div>
      ))}

      {/* Show More / Show Less */}
      {selectedAccounts.length > 2 && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "#b3b3b3 ",
            cursor: "pointer",
            fontSize: "12px",
            userSelect: "none",
          }}
        >
          {expanded
            ? "Show less"
            : // : `Show more (${selectedAccounts.length - 2})`}
              "Show more"}
        </span>
      )}
    </div>
  );
};


const ProductCatalog = ({ handleColorChange }) => {
  // const { selectedProducts, setSelectedProducts } = useAppContext();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const [data, setData] = useState([]);
  const [cartVisible, setCartVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [userAccounts, setUserAccounts] = useState([]);
  const userInfo = useSelector((state) => state.userAuth.decodedToken.user);
  const [allUserFetched, setAllUserFetched] = useState(false);
  const [catalogueFetched, setCatalogueFetched] = useState(false);
  const [activeTab, setActiveTab] = useState("catalogue");
  const [totalPurchaseRec,setTotalPurchaseRec] = useState(0);
  const [purPageSize,setPurPageSize] = useState(10);
  const [purcurrentPage, setPurCurrentPage] = useState(1);
  const SelectedPharmacy = useSelector((state) => {
    return state.pharmacyData?.pharmacyData;
  });
  const [searchText, setSearchText] = useState("");
  const [purHistory,setPurHistory] = useState([]);
  const [fromDate,setFromDate] = useState(() => {
  return dayjs().startOf("month").format("MM-DD-YYYY")});
  const [toDate,setToDate] = useState(() =>
  dayjs().endOf("day").format("MM-DD-YYYY"))
  const [filterLoading,setFilterLoading] = useState(false)

  useEffect(() => {
    const fetchUserAccounts = async () => {
      try {
        const response = await axiosInstance.get(
          `/users/accounts?email=${userInfo?.email}`,
        );
        setUserAccounts(response.data.data.data);
        setAllUserFetched(true);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchUserAccounts();
  }, []);
  const getCatalogueDetails = async (page = 1, limit = 10) => {
    setCatalogueFetched(true);
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        `marketplace/getCatalogDetails?page=${page}&limit=${limit}`,
      );
      setData(response?.data?.data);
      setTotalRecords(response?.data?.pagination?.total_records || 0);
    } catch (error) {
      console.log(error, "erroeoes");
    } finally {
      setIsLoading(false);
    }
  };

  const accountMap = React.useMemo(() => {
    const map = {};
    userAccounts?.forEach((acc) => {
      map[acc.acct_id] = acc.name;
    });
    return map;
  }, [userAccounts]);

  useEffect(() => {
    if (!searchText || searchText === undefined || searchText?.length === 0) {
      getCatalogueDetails(currentPage, pageSize);
    }
  }, [currentPage, pageSize,searchText]);

  // useEffect(()=>{
  //   getPurchaseHIstory(purPageSize,purcurrentPage)
  // },[])
    useEffect(() => {
      getPurchaseHIstory(purcurrentPage, purPageSize,fromDate,toDate);
  }, [purcurrentPage, purPageSize,]);

  // const filteredData = useMemo(() => {
  //   return data?.filter((product) =>
  //     product?.product_name?.toLowerCase().includes(searchText.toLowerCase()),
  //   );
  // }, [data, searchText]);
   const getSearchData = async () => {
    if (!searchText) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await axiosInstance.get("marketplace/search", {
        params: {
          catalog_id: data?.[0]?.catalog_id,
          search_term: searchText,
        },
      });

      setData(response?.data?.data || []);
      setTotalRecords(response?.data?.data?.length || 0);
    } catch (error) {
      console.error("Search error:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useLayoutEffect(() => {
    handleColorChange("#FFFFFF");
  }, []);
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const getCartData = async () => {
    try {
      const response = await axiosInstance.get(
        `marketplace/cart/${userAuth?.id}`,
      );
      setSelectedProducts(response?.data?.items);
      setCartVisible(true);
    } catch (error) {
      console.log(error, "erorro");
    }
  };

  // useEffect(()=>{
  //   getCartData();
  // },[cartVisible])
  // useEffect(() => {
  //   const filtered = AllUser.filter(
  //     (user) =>
  //       user.name?.toLowerCase().includes(searchPharm.toLowerCase()) ||
  //       String(user?.acct_id || "").includes(searchPharm.toLowerCase())
  //   );
  //   setFilteredUsers(filtered);
  // }, [searchPharm, AllUser]);

  // const getPurchaseHIstory = async (page,limit,fromDate,toDate) => {
  //   let url;
  //   setFilterLoading(true)
  //   if(fromDate && toDate){
  //     url = `marketplace/purchase-history?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`;
  //   }else{
  //     url = `marketplace/purchase-history?page=${page}&limit=${limit}`;
  //   }
  //   try {
  //     const response = await axiosInstance.get(url);
  //     setPurHistory(response?.data?.data);
  //     setTotalPurchaseRec(response?.data?.pagination?.totalRecords);
  //     setPurCurrentPage(response?.data?.pagination?.currentPage);
  //     setPurPageSize(response?.data?.pagination?.pageSize);
  //   } catch (error) {
  //     console.log(error, "erroeoes");
  //   } finally {
  //     setFilterLoading(false)
  //   }
  // };
   const getPurchaseHIstory = async (page,limit,fromDate,toDate) => {
    let url;
    setFilterLoading(true)
    if(fromDate && toDate){
      url = `marketplace/purchase-order-history?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`;
    }else{
      url = `marketplace/purchase-order-history?page=${page}&limit=${limit}`;
    }
    try {
      const response = await axiosInstance.get(url);
      setPurHistory(response?.data);
      setTotalPurchaseRec(response?.data?.pagination?.totalRecords);
      setPurCurrentPage(response?.data?.pagination?.currentPage);
      setPurPageSize(response?.data?.pagination?.pageSize);
    } catch (error) {
      console.log(error, "erroeoes");
    } finally {
      setFilterLoading(false)
    }
  };
  return (
    <div className="bg-gray-50">
      {/* <div className="sticky top-0 z-50 bg-white shadow"> */}
      <HeaderCompo initialColor="#000833" />
      {/* </div> */}
      <Content className="p-6 bg-[#000833] mb-8 m-2 rounded-lg ">
        <div className="flex flex-col justify-between align-center  sm:flex-row sm:justify-between sm:items-center mb-4 mt-2 gap-4 w-full">
          <div className="order-2 sm:order-1">
            <StaticAccounts
              selectedAccounts={SelectedPharmacy}
              accountMap={accountMap}
            />
          </div>
          <div className="order-1 sm:order-2 flex justify-center sm:justify-start">
            <Image
              style={{ marginTop: "6px", marginBottom: "28px" }}
              src={logo}
              alt="Logo"
              preview={false}
              className=" rounded-md"
              width={200}
              height={60}
            />
          </div>
        </div>
      </Content>
      <Content className="p-4 sm:p-6">
        <div className="max-w-[1400px] mx-0">
          <div className="bg-white rounded-xl shadow-sm p-2 w-fit">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              className="custom-tabs-new"
              size="large"
              items={[
                {
                  key: "catalogue",
                  label: (
                    <span className="flex items-center gap-2 px-4 py-2 rounded-lg">
                      <ShoppingCartOutlined />
                      <span className="hidden sm:inline">
                        Product Catalogue
                      </span>
                      {/* <span className="sm:hidden">Catalogue</span> */}
                    </span>
                  ),
                },
                {
                  key: "history",
                  label: (
                    <span className="flex items-center gap-2 px-4 py-2 rounded-lg">
                      <HistoryOutlined />
                      <span className="hidden sm:inline">Purchase History</span>
                      {/* <span className="sm:hidden">History</span> */}
                    </span>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </Content>
      {
        activeTab === "catalogue" ? 
      <div className="p-3 px-6 font-sans">
        <div className="flex flex-col gap-3 ">
          <div className="flex flex-col sm:flex-row sm:justify-between items-center sm:flex-wrap gap-4 w-full md:w-auto mt-2">
            <h1 className="text-3xl font-bold text-center text-[#040b35]">
              AdvantEdge Catalog
            </h1>
            <div className="flex  sm:flex-row gap-2 w-full items-center md:w-auto">
              <div className="flex gap-2 w-full">
                {/* <div style={{border: "1px solid var(--Primary-Dark-Blue, #000833)",}} className="w-full md:w-[350px]  relative">
                <Input
                  placeholder="Search ..."
                  // suffix={<SearchOutlined className="bg-blue-50 p-3 rounded-lg"/>}
                  value={searchText}
                  onChange={handleSearch}
                  // onChange={(e) => setSearchText(e.target.value)}
                  style={{
                    border: "none",
                    // paddingRight: "48px",
                  }}
                />
                <div
                  onClick={getSearchData}
                  className="absolute top-1/2 right-1 -translate-y-1/2
                             bg-[#f7feff] hover:bg-blue-50
                             p-2 rounded-md cursor-pointer
                             flex items-center justify-center"
                >
                  <SearchOutlined className="text-gray-700 text-lg" />
                </div>
              </div> */}
                <div
                  className="w-full md:w-[350px] flex items-center overflow-hidden rounded-md"
                  style={{ border: "1px solid #000833" }}
                >
                  {/* Input */}
                  <Input
                    placeholder="Search by NDC/Prod ID or Description"
                    value={searchText}
                    onChange={handleSearch}
                    bordered={false}
                    className="flex-1 px-3"
                  />

                  {/* Search Button */}
                  <button
                    onClick={getSearchData}
                    className="h-full px-4 bg-[#f7feff] hover:bg-blue-50
               flex items-center justify-center
               border-l border-[#000833]"
                  >
                    <SearchOutlined className="text-gray-700 text-lg" />
                  </button>
                </div>
                </div>
              {/* <div className="w-full md:w-[350px]">
                <Input
                  placeholder="Search Lamictal XR"
                  suffix={<SearchOutlined />}
                  value={searchText}
                  onChange={handleSearch}
                  // onChange={(e) => setSearchText(e.target.value)}
                  style={{
                    border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  }}
                /> */}
              {/* </div> */}
              <div className="gap-2 flex flex-row md:justify-between justify-start w-[120px] md:w-auto">
                <Button
                  // type="primary"
                  icon={<ShoppingCartOutlined />}
                  onClick={() => getCartData()}
                  className=" w-[120px] md:w-[120px] !bg-[#001997] hover:!bg-[#061561] text-white border-none     hover:!text-white"
                >
                  Quick Cart
                </Button>
              </div>
            </div>
          </div>
        </div>
        <ProductTable
          setData={setData}
          data={data}
          products={data}
          loading={isLoading}
          current={currentPage}
          pageSize={pageSize}
          total={totalRecords}
          onPageChange={(page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          }}
        />

        <CartDrawer
          visible={cartVisible}
          onClose={() => setCartVisible(false)}
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
          getCartData={getCartData}
          getCatalogueDetails={getCatalogueDetails}
          pageSize={pageSize}
          currentPage={currentPage}
        />
      </div>
      : 
      <PurchaseHistory PurchaseHistory={purHistory} fromDate={fromDate} toDate = {toDate} setFromDate={setFromDate} setToDate={setToDate} getPurchaseHIstory={getPurchaseHIstory}filterLoading={filterLoading}
       current={purcurrentPage}
          pageSize={purPageSize}
          total={totalPurchaseRec}
          onPageChange={(page, size) => {
            setPurCurrentPage(page);
            setPurPageSize(size);
          }}/>
      }
    </div>
  );
};

export default ProductCatalog; 	 